module.exports = "<div ng-transclude></div>\n";